import {PermissionCellAbstract} from "./AbstractCell";
import expirydateHtml from './expirydate.html?raw';

export let template = expirydateHtml;

export class viewModel extends PermissionCellAbstract {
}
